export interface ProfileCompanyMembership {
  id: string;
  companyId?: string | null;
  avatar?: string | null;
  company?: { id?: string; name?: string | null } | null;
}

interface ProfileSwitchOptionsProps {
  personalAvatar: string | null;
  initials: string;
  memberships: ProfileCompanyMembership[];
  activeCompanyId: string | null;
  personalSelected: boolean;
  personalAvailable: boolean;
  switching: boolean;
  onSwitch: (companyId: string | null) => void;
}

export default function ProfileSwitchOptions({
  personalAvatar,
  initials,
  memberships,
  activeCompanyId,
  personalSelected,
  personalAvailable,
  switching,
  onSwitch,
}: ProfileSwitchOptionsProps) {
  const avatar = (image: string | null | undefined) =>
    image ? (
      <img
        src={image}
        alt=""
        className="h-7 w-7 shrink-0 rounded-full object-cover"
      />
    ) : (
      <span
        aria-hidden="true"
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-neutral-100 text-xs font-semibold dark:bg-neutral-800"
      >
        {initials}
      </span>
    );
  const classes =
    "flex w-full items-center gap-2 rounded-lg px-2 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-50 disabled:cursor-not-allowed disabled:opacity-50 dark:text-neutral-300 dark:hover:bg-neutral-800";

  return (
    <>
      <button
        type="button"
        disabled={switching || !personalAvailable}
        aria-pressed={personalSelected}
        title={
          !personalAvailable
            ? "Open an event to select your personal profile"
            : undefined
        }
        onClick={() => onSwitch(null)}
        className={classes}
      >
        {avatar(personalAvatar)}
        <span className="min-w-0 flex-1 truncate">Personal Profile</span>
        {personalSelected && <span aria-hidden="true">✓</span>}
      </button>
      {memberships.map((membership) => {
        const companyId = membership.companyId ?? membership.company?.id;
        if (!companyId || !membership.company?.name) return null;
        const selected = !personalSelected && companyId === activeCompanyId;
        return (
          <button
            key={membership.id}
            type="button"
            disabled={switching}
            aria-pressed={selected}
            onClick={() => onSwitch(companyId)}
            className={classes}
          >
            {avatar(membership.avatar)}
            <span className="min-w-0 flex-1 truncate">
              {membership.company.name}
            </span>
            {selected && <span aria-hidden="true">✓</span>}
          </button>
        );
      })}
    </>
  );
}
